var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLarge = function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 188 189"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94.835,
    r: 91,
    fill: "#EF7700",
    stroke: "#fff",
    strokeWidth: 6,
    transform: "rotate(5 94 94.835)"
  })));
};
export default SvgLarge;